function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import { pickBy, isNumber, startsWith, flatMap, take, flatten } from "lodash";
import { Suggest } from "@blueprintjs/select";
import "./style.css";
import { Popover, Position, Menu, Button } from "@blueprintjs/core";
import { some } from "lodash";
import { createDynamicMenu, DynamicMenuItem, getStringFromReactComponent, doesSearchValMatchText } from "../utils/menuUtils";
import { comboToLabel, withHotkeys } from "../utils/hotkeyUtils";

var MenuBar = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MenuBar, _React$Component);

  function MenuBar(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false,
      openIndex: null,
      helpItemQueryStringTracker: "" //we use this to track the search value and to not do all the item rendering logic until someone is actually searching

    });

    _defineProperty(_assertThisInitialized(_this), "handleInteraction", function (index) {
      return function (newOpenState) {
        if (!newOpenState && index !== _this.state.openIndex) {
          return; //return early because the "close" is being fired by another popover
        }

        _this.setState({
          isOpen: newOpenState,
          openIndex: newOpenState ? index : null
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseOver", function (index) {
      return function () {
        var isOpen = _this.state.isOpen;

        if (isOpen) {
          _this.setState({
            openIndex: index
          });
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getAllMenuItems", function () {
      var _this$props = _this.props,
          menu = _this$props.menu,
          enhancers = _this$props.enhancers,
          context = _this$props.context;
      return getAllMenuTextsAndHandlers(menu, enhancers, context);
    });

    _defineProperty(_assertThisInitialized(_this), "addHelpItemIfNecessary", function (menu, i) {
      return menu.map(function (item, innerIndex) {
        var isMenuSearch = item.isMenuSearch,
            inputProps = item.inputProps,
            rest = _objectWithoutPropertiesLoose(item, ["isMenuSearch", "inputProps"]);

        if (isMenuSearch) {
          var isTopLevelSearch = !isNumber(i);
          _this.isTopLevelSearch = isTopLevelSearch;
          _this.menuSearchIndex = isTopLevelSearch ? innerIndex : i;
          return {
            shouldDismissPopover: false,
            text: /*#__PURE__*/React.createElement(Suggest, _extends({
              closeOnSelect: false,
              items: _this.state.helpItemQueryStringTracker ? _this.getAllMenuItems() : [],
              itemListPredicate: filterMenuItems,
              itemDisabled: function itemDisabled(i) {
                return i.disabled;
              },
              popoverProps: {
                minimal: true,
                popoverClassName: "tg-menu-search-suggestions"
              },
              onQueryChange: function onQueryChange(val) {
                _this.setState({
                  helpItemQueryStringTracker: val
                });
              },
              className: "tg-menu-bar-help-search",
              resetOnSelect: false,
              resetOnClose: true,
              inputProps: _extends({
                inputRef: function inputRef(n) {
                  if (n) {
                    _this.searchInput = n;
                    n.setAttribute && n.setAttribute("size", n.getAttribute("placeholder").length);
                  }
                },
                autoFocus: !isTopLevelSearch,
                placeholder: "Search the menus (" + comboToLabel(_this.props.menuSearchHotkey || menuSearchHotkey, false).replace(/\s/g, "") + ")"
              }, inputProps),
              initialContent: null,
              onItemSelect: _this.handleItemClickOrSelect(),
              inputValueRenderer: function inputValueRenderer(i) {
                return i.text;
              },
              noResults: /*#__PURE__*/React.createElement("div", null, "No Results..."),
              itemRenderer: _this.helpItemRenderer
            }, rest))
          };
        } else {
          return item;
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "helpItemRenderer", function (i, b) {
      // if (i.submenu.length === 3) debugger;
      return /*#__PURE__*/React.createElement(DynamicMenuItem, {
        key: b.index,
        doNotEnhanceTopLevelItem: true,
        enhancers: _this.props.enhancers,
        def: _extends({}, i, {
          text: i.isSimpleText ? i.justText || i.text : i.text,
          label: i.path.length && /*#__PURE__*/React.createElement("span", {
            style: {
              fontSize: 8
            }
          }, flatMap(i.path, function (el, i2) {
            if (i2 === 0) return el;
            return [" > ", el];
          })),
          onClick: _this.handleItemClickOrSelect(i),
          active: b.modifiers.active // shouldDismissPopover: true,

        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleItemClickOrSelect", function (__i) {
      return function (_i) {
        var i = __i || _i;
        if (!i.onClick) return;
        !i.disabled && i.onClick();

        if (i.shouldDismissPopover !== false) {
          _this.setState({
            isOpen: false
          });
        } else {
          if (_i && _i.stopPropagation) {
            _i.stopPropagation();

            _i.preventDefault();
          }
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "toggleFocusSearchMenu", function () {
      if (!isNumber(_this.menuSearchIndex)) return; //toggle off

      if (_this.searchInput && document.activeElement === _this.searchInput) {
        _this.searchInput.blur();

        _this.setState({
          isOpen: false,
          openIndex: _this.menuSearchIndex
        });
      } else {
        //toggle on
        if (_this.isTopLevelSearch) {
          _this.searchInput && _this.searchInput.focus();
        } else {
          _this.setState({
            isOpen: true,
            openIndex: _this.menuSearchIndex
          });
        }
      }
    });

    var combo = _this.props && _this.props.menuSearchHotkey || menuSearchHotkey;
    _this.hotkeyEnabler = withHotkeys({
      searchHotkey: {
        allowInInput: true,
        global: true,
        combo: combo,
        label: "Search the menu",
        preventDefault: true,
        stopPropagation: true,
        onKeyDown: _this.toggleFocusSearchMenu
      }
    });
    return _this;
  }

  var _proto = MenuBar.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        className = _this$props2.className,
        style = _this$props2.style,
        menu = _this$props2.menu,
        enhancers = _this$props2.enhancers,
        extraContent = _this$props2.extraContent;
    var _this$state = this.state,
        isOpen = _this$state.isOpen,
        openIndex = _this$state.openIndex;
    return /*#__PURE__*/React.createElement("div", {
      className: "tg-menu-bar " + className,
      style: style
    }, /*#__PURE__*/React.createElement(this.hotkeyEnabler, null), menu.map(function (topLevelItem, i) {
      var dataKeys = pickBy(topLevelItem, function (value, key) {
        return startsWith(key, "data-");
      }); // Support enhancers for top level items too

      topLevelItem = enhancers.reduce(function (v, f) {
        return f(v);
      }, topLevelItem);

      if (topLevelItem.hidden) {
        return null;
      }

      var button = /*#__PURE__*/React.createElement(Button, _extends({}, dataKeys, {
        //spread all data-* attributes
        key: i,
        elementRef: function elementRef(n) {
          if (!n) return;
          _this2.n = n;
        },
        minimal: true,
        className: "tg-menu-bar-item",
        onClick: topLevelItem.onClick,
        disabled: topLevelItem.disabled,
        onMouseOver: topLevelItem.submenu ? _this2.handleMouseOver(i) : noop
      }), topLevelItem.text);
      var vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
      var maxHeight = vh - (_this2.n && _this2.n.getBoundingClientRect().y + 70 || 70);
      return !topLevelItem.submenu ? button : /*#__PURE__*/React.createElement(Popover, {
        autoFocus: false,
        key: i,
        minimal: true,
        canEscapeKeyClose: true,
        onClosed: function onClosed() {
          _this2.setState({
            helpItemQueryStringTracker: ""
          });

          _this2.props.onMenuClose && _this2.props.onMenuClose();
        },
        portalClassName: "tg-menu-bar-popover",
        position: Position.BOTTOM_LEFT,
        isOpen: isOpen && i === openIndex,
        onInteraction: _this2.handleInteraction(i),
        content: /*#__PURE__*/React.createElement(Menu, {
          style: some(topLevelItem.submenu, function (n) {
            return n.isMenuSearch;
          }) //tnrbp4upgrade - I added this logic to prevent the Search Suggest component popover from covering the suggest. Remove this once we're on bp4 (shouldn't be necessary according to https://github.com/palantir/blueprint/issues/4552)
          ? {} : {
            maxHeight: maxHeight,
            overflow: "auto"
          }
        }, createDynamicMenu(_this2.addHelpItemIfNecessary(topLevelItem.submenu, i), enhancers)),
        transitionDuration: 0,
        style: {
          transition: "none"
        },
        inline: true
      }, button);
    }), extraContent);
  };

  return MenuBar;
}(React.Component);

_defineProperty(MenuBar, "defaultProps", {
  className: "",
  style: {}
});

function noop() {}

var isDivider = function isDivider(item) {
  return item.divider !== undefined;
};

function getAllMenuTextsAndHandlers(menu, enhancers, context, path) {
  if (path === void 0) {
    path = [];
  }

  if (!menu) return [];
  return flatMap(menu, function (item) {
    var enhancedItem = [].concat(enhancers).reduce(function (v, f) {
      return f(v, context);
    }, item);

    if (isDivider(enhancedItem)) {
      return [];
    }

    if (enhancedItem && enhancedItem.hidden) return [];
    return [_extends({}, enhancedItem, {
      path: path
    })].concat(getAllMenuTextsAndHandlers(enhancedItem.submenu, enhancers, context, [].concat(path, [enhancedItem.text])));
  });
}

var filterMenuItems = function filterMenuItems(searchVal, items) {
  var newItems = flatMap(items, function (item) {
    var text = item.text,
        onClick = item.onClick,
        hidden = item.hidden,
        hideFromMenuSearch = item.hideFromMenuSearch,
        hiddenButSearchableText = item.hiddenButSearchableText,
        showInSearchMenu = item.showInSearchMenu,
        component = item.component;

    if (!showInSearchMenu && !component && (!text || !onClick || !searchVal || hideFromMenuSearch || hidden)) {
      return [];
    } //fix this to use some smart regex


    var justText = text;
    var isSimpleText = true;

    if (!text.toLowerCase) {
      if (text.props) {
        isSimpleText = false;
        justText = getStringFromReactComponent(text);
      } else {
        return [];
      }
    }

    if (doesSearchValMatchText(searchVal, hiddenButSearchableText ? justText + " " + hiddenButSearchableText : justText)) {
      return _extends({}, item, {
        justText: justText,
        isSimpleText: isSimpleText
      });
    } else {
      return [];
    }
  }).sort(function (a, b) {
    return a.justText.length - b.justText.length;
  });
  return take(newItems, 10).map(function (i) {
    return _extends({}, i, {
      justText: highlight(searchVal, i.justText)
    });
  });
};

var menuSearchHotkey = "meta+/";

function highlight(query, text, opts) {
  opts = opts || {
    tag: /*#__PURE__*/React.createElement("strong", null)
  };

  if (query.length === 0) {
    return text;
  }

  var offset = text.toLowerCase().indexOf(query[0].toLowerCase());
  if (offset === -1) return text;
  var last = 0;

  for (var i = 1; i < query.length; i++) {
    if (text[offset + i] !== query[i]) {
      break;
    }

    last = i;
  }

  var before = text.slice(0, offset);
  var match = /*#__PURE__*/React.createElement("strong", null, text.slice(offset, offset + last + 1));
  var after = highlight(query.slice(last + 1), text.slice(offset + last + 1), opts);
  return flatten([before, match, after]);
}

export default MenuBar;